import SignUpPassengerFormAccountData from "./types/sign-up-passenger-form-account-data";
import SignUpPassengerAddress from "./types/sign-up-passenger-address";
import SignUpPassengerFormUserData from "./types/sign-up-passenger-form-user-data";
import PassengerAddParams, {
  PassengerAddParamsPassenger,
  PassengerAddParamsPassengerAddress,
} from "../../../../../common/services/passenger/add/passenger-add-params";

const createSignUpRequestAddresses = (
  userDataAddresses: SignUpPassengerAddress[],
): PassengerAddParamsPassengerAddress[] => {
  return userDataAddresses.map(createSignUpRequestAddress);
};

const createSignUpRequestAddress = (
  userDataAddress: SignUpPassengerAddress,
): PassengerAddParamsPassengerAddress => {
  return {
    apartment: userDataAddress.apartmentNumber.trim(),
    country: userDataAddress.country.trim(),
    description: userDataAddress.description.trim(),
    houseNo: userDataAddress.houseNumber.trim(),
    lat: userDataAddress.latitude,
    lon: userDataAddress.longitude,
    street: userDataAddress.street.trim(),
    town: userDataAddress.town.trim(),
    zipCode: userDataAddress.zipCode.trim(),
  };
};

const createPassenger = (
  userData: SignUpPassengerFormUserData,
  dispatchId: string,
): PassengerAddParamsPassenger => {
  return {
    addresses: createSignUpRequestAddresses(userData.addresses),
    dispatchIds: [dispatchId],
  };
};

const createSignUpRequest = ({
  accountData,
  userData,
  dispatchId,
}: {
  accountData: SignUpPassengerFormAccountData;
  userData: SignUpPassengerFormUserData;
  dispatchId: string;
}): PassengerAddParams => {
  return {
    firstName: userData.firstName.trim(),
    lastName: userData.lastName.trim(),
    mobilePrimaryPrefix: userData.mobile.dialingCode!,
    mobilePrimary: userData.mobile.number!,
    mobileSecondaryPrefix: userData.alternativeMobile.dialingCode,
    mobileSecondary: userData.alternativeMobile.number,
    email: accountData.email.trim(),
    username: accountData.username.trim(),
    password: accountData.password,
    passenger: createPassenger(userData, dispatchId),
  };
};

const signUpPassengerFormFactory = {
  createSignUpRequest,
  createSignUpRequestAddress,
};

export default signUpPassengerFormFactory;
